export default "__VITE_ASSET__Cro22bbN__"